import { render, staticRenderFns } from "./CustomReportPage10.vue?vue&type=template&id=e2938cd0&scoped=true&"
import script from "./CustomReportPage10.vue?vue&type=script&lang=js&"
export * from "./CustomReportPage10.vue?vue&type=script&lang=js&"
import style0 from "./CustomReportPage10.vue?vue&type=style&index=0&id=e2938cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2938cd0",
  null
  
)

export default component.exports